<app-header [selectedMenu]="MENU_PAGE.OPEN_SOURCE"></app-header>

<div class="container">

  <div class="wrapper">

    <aside class="rope"
           (click)="onClickRope($event)"></aside>

    <section class="setting">

      <div class="inner wrap">


        <div class="setting-box">


          <article class="book-layout">

            <div class="book-layout-wrap type-page-list-none">

              <div class="book-page-list">


                <div class="book-page-group">
                  <div class="page-box">
                    <div #container
                         class="page-content scroll-effect over-y">
                      <div class="list-wrap">
                        <ul>
                          <li>
                            <div class="item-box">
                              <div class="item-head-box">
                                <div class="subject-box">오픈 소스 라이선스 고지</div>
                                <div class="sub-box type-small">듣고 배우는 한국어 버전:
                                  <span (click)="onClearData($event)">{{ APP_VERSION }}</span>
                                </div>
                                <!-- a class="sub-box type-small"
                                   (click)="onClearData($event)">저장된 데이터 지우기</a -->
                              </div>
                            </div>
                          </li>

                          <li *ngFor="let license of listLicense">
                            <div class="item-box">
                              <div class="item-head-box">
                                <div class="subject-box">{{ license.name }}</div>
                                <div class="sub-box grid">
                                  <ng-container *ngIf="license.version">
                                    <div class="sub-txt">버전:</div>
                                    <div class="con-txt">{{ license.version }}</div>
                                  </ng-container>

                                  <ng-container *ngIf="license.licenses">
                                    <div class="sub-txt">라이선스:</div>
                                    <div class="con-txt" (click)="onClickLicense($event, license)">
                                      <span [class.link]="license.licenseFile || license.licenseUrl"
                                            (click)="license.licenseFile ? onClickLicense($event, license) : (
                                              license.licenseUrl ? onClickUrl($event, license.licenseUrl) : null)">
                                        {{ license.licenses }}
                                      </span>
                                    </div>
                                  </ng-container>

                                  <ng-container *ngIf="license.publisher">
                                    <div class="sub-txt">발행자:</div>
                                    <div class="con-txt">{{ license.publisher }}</div>
                                  </ng-container>

                                  <ng-container *ngIf="license.email">
                                    <div class="sub-txt">이메일 주소:</div>
                                    <div class="con-txt"><a href="mailto:{{ license.email }}">{{ license.email }}</a></div>
                                  </ng-container>

                                  <ng-container *ngIf="license.url">
                                    <div class="sub-txt">홈페이지:</div>
                                    <div class="con-txt"><a href="{{ license.url }}">{{ license.url }}</a></div>
                                  </ng-container>

                                  <ng-container *ngIf="license.repository">
                                    <div class="sub-txt">저장소:</div>
                                    <div class="con-txt"><a href="{{ license.repository }}">{{ license.repository }}</a></div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="page-box ">
                    <div #licenseContent
                         class="page-content scroll-effect over-y">
                      <markdown class="md"
                                [data]="dataMarkdown"></markdown>
                    </div>

                  </div>

                  <div class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>

  </div>

  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>
<app-back-btn></app-back-btn>
